import { Action } from "redux";

import { OrganizationKeyName } from "../../../model/Organization";
import { AdminUser } from "../../../service/api-response/AdminUserSuccessResponse";

export const GET_ADMIN_USER_SUCCESS = "ADMIN_USER:GET_ADMIN_USER_SUCCESS";

export interface GetAdminUserSuccessAction extends Action {
  type: typeof GET_ADMIN_USER_SUCCESS;
  organization: OrganizationKeyName;
  id: string;
  data: AdminUser;
}

export const getAdminUserSuccessAction = (
  organization: OrganizationKeyName,
  id: string,
  story: AdminUser
): GetAdminUserSuccessAction => ({
  type: GET_ADMIN_USER_SUCCESS,
  organization,
  id,
  data: story,
});
